/** App-wide fallback when there is no active perspective or the name is unknown. */
export const DEFAULT_PERSPECTIVE_FAVICON = '/favicon.svg';

/** Single source of truth: perspective name -> favicon path (served from public/). */
export const perspectiveFavicon: Record<string, string> = {
  Veiligheid: '/favicon.svg',
  GHOR: '/favicon-ghor.svg',
  Brandweer: '/favicon-brandweer.svg',
  Politie: '/favicon-politie.svg',
};

export function faviconForPerspective(name: string | null | undefined): string {
  return (name != null ? perspectiveFavicon[name] : undefined) ?? DEFAULT_PERSPECTIVE_FAVICON;
}
